export enum PaymentPeriod {
  Month = "month",
  HalfYear = "6months",
  Year = "year",
}
